import React from "react";
import "./PrivacyPolicy.css";

const PrivacyPolicy = () => {
  return (
    <div className="vp-privacy-wrapper">
      <div className="vp-privacy-container">
        <h1 className="vp-privacy-title">Privacy Policy</h1>

        <p>
          At CM Group of Companies, we respect your privacy and are committed to
          protecting any personal information you share with us. This Privacy
          Policy explains how we collect, use, store, and safeguard your data
          when you visit our website or interact with our services.
        </p>

        <h2>1. Information We Collect</h2>
        <p>We may collect the following types of information:</p>
        <ul>
          <li>Personal details such as name, phone number, email address, and organization name.</li>
          <li>Information submitted through enquiry or contact forms.</li>
          <li>Technical data such as IP address, browser type, device information, and pages visited.</li>
          <li>Cookies and similar technologies to improve website functionality and performance.</li>
        </ul>

        <h2>2. How We Use Your Information</h2>
        <p>Your information may be used for the following purposes:</p>
        <ul>
          <li>Responding to enquiries and providing requested information.</li>
          <li>Communicating about our land development and renewable energy services.</li>
          <li>Improving website performance, security, and user experience.</li>
          <li>Internal analysis, reporting, and operational improvements.</li>
        </ul>

        <h2>3. Data Protection & Security</h2>
        <p>
          We take reasonable technical and organizational measures to protect
          your personal information from unauthorized access, misuse, loss, or
          alteration. However, no method of data transmission over the internet
          is completely secure.
        </p>

        <h2>4. Sharing of Information</h2>
        <p>
          CM Group of Companies does not sell, rent, or trade your personal data.
          Information may be shared only with:
        </p>
        <ul>
          <li>Trusted service providers who assist in website operations.</li>
          <li>Legal or regulatory authorities when required by law.</li>
        </ul>

        <h2>5. Cookies</h2>
        <p>
          Our website uses cookies to enhance user experience and analyze website
          traffic. You may choose to disable cookies through your browser
          settings; however, some features of the website may not function
          properly.
        </p>

        <h2>6. External Links</h2>
        <p>
          Our website may contain links to third-party websites. CM Group of
          Companies is not responsible for the privacy practices or content of
          such external sites.
        </p>

        <h2>7. Children's Privacy</h2>
        <p>
          Our services are not intended for individuals under the age of 18. We
          do not knowingly collect personal information from children.
        </p>

        <h2>8. Changes to This Privacy Policy</h2>
        <p>
          We reserve the right to update or modify this Privacy Policy at any
          time. Any changes will be posted on this page, and continued use of
          the website indicates acceptance of the updated policy.
        </p>

        <h2>9. Contact Us</h2>
        <p>
          If you have any questions or concerns regarding this Privacy Policy or
          how your information is handled, please contact CM Group of Companies
          through our official communication channels.
        </p>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
